import script from "./StickyAudioplayer.vue?vue&type=script&setup=true&lang=js"
export * from "./StickyAudioplayer.vue?vue&type=script&setup=true&lang=js"

import "./StickyAudioplayer.vue?vue&type=style&index=0&id=39c71a0c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39c71a0c"]])

export default __exports__